import { render, staticRenderFns } from "./puzzleBook.vue?vue&type=template&id=40f23e3a&scoped=true&"
import script from "./puzzleBook.vue?vue&type=script&lang=js&"
export * from "./puzzleBook.vue?vue&type=script&lang=js&"
import style0 from "./puzzleBook.vue?vue&type=style&index=0&id=40f23e3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f23e3a",
  null
  
)

export default component.exports